// import NOT_FOUND_IMG from "./NOT_FOUND_IMG.jpg";

import no_image from "./NO_IMAGE.jpg";
import no_image2 from "./9169253.jpg";

const NOT_FOUND_IMG = no_image2;
const NO_IMAGE = no_image;

export { NOT_FOUND_IMG, NO_IMAGE };
